import { Alert, AlertIcon, Box, HStack, Text, VStack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  ProjectRevenueWhereColumn,
  useGetProjectCategoriesQuery,
} from "@src/__generated__/urql-graphql";
import { DataTable } from "@src/components/ui-kit";
import { PeriodPicker } from "@src/components/widgets/PeriodPicker";
import { FiltersPanelRoot } from "@src/utils/components/filters/components/filters-panel";
import { FiltersPanelFilters } from "@src/utils/components/filters/components/filters-panel-filters";
import { FiltersPanelSearch } from "@src/utils/components/filters/components/filters-panel-search";
import { observer } from "mobx-react-lite";
import { Fragment, useEffect } from "react";
import type { ProjectReportStore } from "./store";

type Props = {
  store: ProjectReportStore;
};

export const TableNavbar = observer(function TableNavbar({ store }: Props) {
  // const exportModal = useDisclosure();
  const [{ data }] = useGetProjectCategoriesQuery();

  /*
  const [fetch, { loading }] = useProjectsReportExportLazyQuery({
    onCompleted(data) {
      if (data.projectsProfitExport) {
        window.location.href = data.projectsProfitExport;
      }
    },
    ...onError(),
  });
  */

  useEffect(() => {
    if (!data?.projectCategories) return;
    store.where.filtersByColumn
      .get(ProjectRevenueWhereColumn.CategoryId)
      ?.setOptions(
        data.projectCategories.map(({ id, name }) => ({
          value: id,
          label: name,
        })),
      );
  }, [data?.projectCategories]);

  return (
    <Fragment>
      <DataTable.NavBar>
        <Box py="4">
          <FiltersPanelRoot filters={store.where}>
            <VStack align="start" w="full" spacing="4">
              <HStack w="full" spacing="2">
                <PeriodPicker
                  topExtraContent={
                    <Box px="4" pt="4">
                      <Alert borderRadius="md" status="info">
                        <AlertIcon />
                        <Text>
                          <Trans>
                            Show financial data from this selected date range,
                            based on "Date of supply"
                          </Trans>
                        </Text>
                      </Alert>
                    </Box>
                  }
                  customActions={store.periodPickerActions}
                  onChange={store.setDateRange}
                  value={store.dateRange}
                />
                <FiltersPanelSearch
                  w="full"
                  inputWidth="full"
                  searchPlaceholder={t`Search by brand, code, project`}
                  defaultValue={store.searchTerm}
                  onSearch={(val) => {
                    store.searchTerm = val;
                    store.pagination.resetPage();
                  }}
                />
                <FiltersPanelFilters
                  menuPlacement="bottom-start"
                  innerMenuPlacement="right-start"
                />
                {/*
                <Box w="fit-content">
                  <ExportButton
                    isLoading={loading}
                    onClick={exportModal.onOpen}
                  />
                </Box>
                */}
              </HStack>
            </VStack>
          </FiltersPanelRoot>
        </Box>
      </DataTable.NavBar>
      {/*
      <ModalInputDatePicker
        allowRange
        title={t`Choose start and end date`}
        onConfirm={(range) =>
          fetch({
            variables: {
              from: toApiDate(range.start),
              to: toApiDate(range.end),
            },
          })
        }
        {...exportModal}
        confirmLabel={t`Generate`}
      />
      */}
    </Fragment>
  );
});
